/** @type {Record<keyof typeof import("./en.js").default, string>} */
const messages = {
    "colorAxisHelp": "五度圏上で同じ中心軸に属する音を同じ色にまとめます。",
    "colorCircleHelp": "五度圏の順に色相を配置します。同じ音名はオクターブによらず同じ色になります。",
    "colorIntervalHelp": "音高に沿って色相を変え、指定した半音数で一周します。",
    "colorMonotoneHelp": "すべての音を同じ色で表示します。",
    "colorMethod": "配色方式",
    "colorPeriod": "色相の周期",
    "colorCircle": "五度圏",
    "colorInterval": "音程",
    "colorBasis": "色分けの基準",
    "settings": "設定",
    "about": "アプリ情報",
    "settingsTitle": "設定（Ctrl+, または ⌘+,）",
    "close": "閉じる",
    "closeSettings": "設定を閉じる",
    "categories": "設定の分類",
    "connectionTab": "接続",
    "visualizationTab": "可視化",
    "uiTab": "UI",
    "chordsTab": "コード名",
    "immediate": "変更はすぐに反映・保存されます。",
    "errorTitle": "操作を完了できませんでした",
    "recovery": "機器の接続とブラウザーのMIDIアクセス許可を確認し、もう一度お試しください。",
    "dismiss": "閉じる",
    "connection": "MIDI接続",
    "inputDevice": "入力機器",
    "notConnected": "未接続",
    "refresh": "入力機器を再検索",
    "ignoreOctave": "オクターブの違いを無視",
    "ignoreOctaveHelp": "同じ音名のすべてのセルが反応し、オクターブ番号を非表示にします。",
    "arrangementMethod": "配置方式",
    "toolbarHeading": "ツールバー",
    "arrangement": "音の配置",
    "color": "配色",
    "toolbar": "ツールバーを表示",
    "toolbarHelp": "設定ボタンは常に表示されます。",
    "channelColorLabel": "チャンネルの色",
    "inputChannelsTab": "入力チャンネル",
    "inputChannelsHelp": "チャンネルごとに移調量と入力先を設定します。チャンネル10（打楽器）は対象外です。",
    "channelToVisuals": "可視化への入力",
    "channelToChords": "コード名への入力",
    "percussionExcluded": "打楽器用チャンネルのため対象外です。",
    "chords": "調性とコード名",
    "key": "調",
    "mode": "音階・モード",
    "sharp": "シャープで音名を表記",
    "degrees": "コード名を度数で表示",
    "offset": "移調量（半音）",
    "offsetHelp": "−24〜+24半音。12半音で1オクターブです。",
    "offsetError": "−24〜+24の整数を入力してください。変更前の設定が適用されています。",
    "checking": "MIDI入力を確認中…",
    "connected": "接続中：{name}",
    "chooseInput": "未接続です。入力機器を選択してください。",
    "noInputs": "MIDI入力が見つかりません。機器を接続して再検索してください。",
    "unavailable": "MIDI入力を利用できません。アクセス許可を確認し、入力機器を再検索してください。",
    "connecting": "接続中…",
    "disconnecting": "切断中…",
    "errorMissingInput": "このMIDI入力は利用できなくなりました。別の入力を選択するか、一覧を再検索してください。",
    "errorUnsupported": "このブラウザーではWeb MIDIを利用できません。Web MIDI対応のブラウザーを使用してください。",
    "errorPermission": "MIDIへのアクセスが拒否されました。ブラウザーの設定でMIDIアクセスを許可し、入力機器を再検索してください。",
    "errorDevice": "MIDI機器の接続または切断に失敗しました。機器の接続を確認し、もう一度お試しください。",
    "errorUnknown": "予期しないエラーが発生しました。もう一度お試しください。",
    "language": "言語 / Language",
    "automatic": "自動（ブラウザーの言語）",
    "aboutTitle": "Midivisについて",
    "licenses": "ライセンス",
    "licenseIntro": "このアプリケーションのソースコードは、フリーかつオープンソースのライセンスで公開されています。",
    "appLicense": "Midivisのライセンス",
    "thirdParty": "サードパーティーのライセンス",
    "eventsLicense": "Node.jsのライセンス",
    "eventsNotice": "このライセンスはeventsモジュールに適用されます。",
    "color.channel": "MIDIチャンネル",
    "colorChannelHelp": "入力チャンネルごとに色で表示します。同じ音が重なると色の帯で表示します。チャンネル10（打楽器）は対象外です。",
    "color.monotone": "単色",
    "color.chromatic": "12半音（1オクターブ）",
    "color.fifth": "五度圏",
    "color.axis": "中心軸システム",
    "color.quintave": "7半音（完全五度）",
    "color.third-major": "4半音（長三度）",
    "arrangementVariant": "形状・範囲",
    "arrangementGroup.interval": "音程格子",
    "arrangementGroup.harmony": "和声の配置",
    "arrangementGroup.keyboard": "鍵盤・ボタン配列",
    "arrangementGroup.strings": "弦楽器の指板",
    "arrangementVariant.standard": "標準",
    "arrangementVariant.wide": "横長",
    "arrangementVariant.tall": "縦長",
    "arrangementVariant.slanted": "斜め",
    "layoutHelp.third": "横方向に半音ずつ並び、千鳥状の段の間に長三度・短三度の関係が現れます。",
    "layoutHelp.fourth": "横方向に半音ずつ、縦方向に完全四度ずつ並びます。",
    "layoutHelp.tritone": "横方向に半音ずつ、縦方向に三全音ずつ並びます。",
    "layoutHelp.fifth": "横方向に半音ずつ、縦方向に完全五度ずつ並びます。",
    "layoutHelp.octave": "横方向に半音ずつ、縦方向に1オクターブずつ並びます。",
    "layoutHelp.tonnetz": "五度と三度の関係を格子に配置し、和音同士の関係を見渡せます。",
    "layoutHelp.wicki-hayden": "横方向に全音ずつ並ぶ千鳥状の配列です。標準と横長を選べます。",
    "layoutHelp.janko": "横方向に全音ずつ並び、隣の段で半音を補う配列です。",
    "layoutHelp.c-system": "クロマチック・ボタン配列のCシステムです。横方向に短三度ずつ並びます。",
    "layoutHelp.b-system": "クロマチック・ボタン配列のBシステムです。横方向に短三度ずつ並びます。",
    "layoutHelp.guitar": "6弦ギターの標準調弦です（低音から E–A–D–G–B–E）。",
    "layoutHelp.bass": "4弦ベースの標準調弦です（低音から E–A–D–G）。",
    "layout.piano": "ピアノ",
    "layout.piano-vertical": "ピアノ（オクターブを縦に配置）",
    "octaveDirection": "オクターブの並び",
    "arrangementVariant.horizontal": "横方向",
    "arrangementVariant.vertical": "縦方向",
    "layoutHelp.piano": "88鍵のピアノ（A0〜C8）です。横方向は右ほど高く、縦方向は1段1オクターブで上ほど高くなります。",
    "layout.third": "三度配列",
    "layout.fourth-whole-tone": "完全四度–全音",
    "layoutHelp.fourth-whole-tone": "横方向に全音ずつ、縦方向に完全四度ずつ並びます。",
    "layout.fourth": "完全四度",
    "layout.tritone": "三全音",
    "layout.fifth-whole-tone": "完全五度–全音",
    "layoutHelp.fifth-whole-tone": "横方向に全音ずつ、縦方向に完全五度ずつ並びます。",
    "layout.fifth": "完全五度",
    "layout.octave": "オクターブ",
    "layout.wicki-hayden": "Wicki–Hayden",
    "layout.wicki-hayden-wide": "Wicki–Hayden（横長）",
    "layout.tonnetz": "Tonnetz",
    "layout.janko": "Jankó",
    "layout.janko-tall": "Jankó（縦長）",
    "layout.janko-slanted": "Jankó（斜め）",
    "layout.c-system": "Cシステム",
    "layout.b-system": "Bシステム",
    "layout.guitar": "ギター",
    "layout.bass": "ベースギター",
    "mode.2741": "長音階（アイオニアン）",
    "mode.1453": "自然短音階（エオリアン）",
    "mode.2225": "アイオニアン・ペンタトニック",
    "mode.661": "メジャー・ペンタトニック",
    "mode.1189": "サスペンデッド・ペンタトニック",
    "mode.1193": "マイナー・ペンタトニック",
    "mode.397": "エオリアン・ペンタトニック",
    "mode.4095": "半音階"
}
export default messages
